
export enum PersonalViewLocation {

    HOME                = 1,
    HOME_MORE           = 2,
    NAVIGATION_PANEL    = 3,

}